var React = require('react');

function Notification (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 0a1.5 1.5 0 011.5 1.5v3.073c8.325.813 14.722 8.313 14.991 16.662.063 1.929.16 4.035.306 6.317.205 3.216 1.701 7.524 2.342 9.233a2.01 2.01 0 01-1.88 2.715H6.74a2.01 2.01 0 01-1.88-2.715c.64-1.709 2.137-6.017 2.342-9.233.145-2.282.244-4.388.306-6.317.27-8.348 6.666-15.849 14.991-16.662V1.5A1.5 1.5 0 0124 0zm0 7.5c-7.233 0-13.253 6.406-13.493 13.832-.063 1.96-.163 4.098-.31 6.41-.19 2.974-1.29 6.574-2.045 8.758h31.696c-.756-2.184-1.855-5.784-2.045-8.758-.147-2.312-.247-4.45-.31-6.41C37.253 13.906 31.233 7.5 24 7.5z","key":0}),React.createElement("path",{"d":"M21.74 43.147a1.5 1.5 0 10-2.943.581 5.306 5.306 0 0010.406 0 1.5 1.5 0 00-2.942-.581 2.306 2.306 0 01-4.521 0z","key":1})]);
}

Notification.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Notification;

Notification.default = Notification;
